import { render, staticRenderFns } from "./Applicants.vue?vue&type=template&id=ad19a1f2&"
import script from "./Applicants.vue?vue&type=script&lang=ts&"
export * from "./Applicants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports